import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-current-product',
  templateUrl: './endasure-current-product.component.html',
  styleUrls: ['./endasure-current-product.component.scss'],
  standalone: false
})
export class EndasureCurrentProductComponent {
  @Input() brandOfActuator: any;
  private readonly destroy$ = new Subject<void>();

  constructor(public endasureService: EndasureService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.endasureService.currentProdData$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      console.log('currentProdData', data);
      if (data != null) {
        this.currentProductForm.patchValue({
          brandOfActuator: data.brandOfActuator || 'Haldex Gold Seal',
        });
      }
    });
  }

  currentProductForm = new FormGroup({
    brandOfActuator: new FormControl('Haldex Gold Seal'),
  });

  endaSureNxt() {
    this.endasureService.currentProdData$.next(this.currentProductForm.value);
    this.endasureService.currentComponent$.next('csaDowntime');
    this.cdr.detectChanges();
  }
  endaSureBack() {
    this.endasureService.currentComponent$.next('replacementCost');
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
